import { UserInteraction } from '../models';

import { useUserInteraction } from './use-user-interaction';

export const useInteractionHandler = (universityId?: string) => {
  const { mutate } = useUserInteraction();

  const onInteractionClick = (action: UserInteraction) => () => {
    mutate({ universityId, action });
  };

  return { onInteractionClick };
};
